import { useEffect, useRef, useState } from "react";
import 'react-accessible-accordion/dist/fancy-example.css';
import ReactPaginate from "react-paginate";
import { connect, useDispatch } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import Select from "react-select";
import { Col, Row, Table } from "reactstrap";
import { logout } from "../../../../store/actions/AuthActions";
import { api } from "../../../../utils/api";
import { shownItem } from "../../../../utils/config";
import { translate } from "../../../../utils/translate";
import LoadingV3 from "../../../components/Loading/LoadingV3";
import customSelectStyles from '../../SelectStyle';
import NotFound from "../../Common/NotFound";

const statusList = [
    { value: 'Active', label: 'Active' },
    { value: 'Disabled', label: 'Inactive' },
    { value: 'Deleted', label: 'Deleted' },
]

const Announcement = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const [productPerpage, setProductPerPage] = useState(10);
    const [pageCount, setPageCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [result, setResult] = useState([]);
    const [status, setStatus] = useState('Active');
    const [firstLoad, setFirstLoad] = useState(true)
    const changePage = (event) => {
        setPageNumber(event.selected + 1);
        getList(event.selected + 1)
    }
    const timerRef = useRef(null);

    useEffect(() => {
        getList();
        setFirstLoad(false);
    }, [props.lang]);

    useEffect(() => {
        if (!firstLoad) {
            setPageNumber(1);
            getList(1);
        }
    }, [status, productPerpage]);


    const getList = () => {
        setLoading(true);
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            let url = api.get_announcements + `?page=${pageNumber}&type=announcement`;
            if (productPerpage) {
                url = url + `&limit=${productPerpage}`
            }
            if (status) {
                url += `&status=${status}`
            }

            fetch(url, {
                method: "GET",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "Accept-Language": "en",
                    "Authorization": "Bearer " + props.auth.auth.access_token
                }),
            })
                .then(response => response.json())
                .then(responseJson => {
                    setTimeout(() => {
                        setLoading(false);
                    }, 1000);
                    if (responseJson.status === "success") {
                        setResult(responseJson.data.results);
                        var pageCount = Math.ceil(responseJson.data.total_results / productPerpage)
                        setPageCount(pageCount);
                    } else {
                        if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                            dispatch(logout(props.history, 'login'));
                        }
                        console.log("error", responseJson.message);
                    }
                }).catch(error => {
                    console.error("error", error);
                });
        }, 1000);
    }

    const edit = (id) => {
        history.push(`/system/announcement/${id}`);
    }

    return (
        <>
            <div className='pb-5 wallet'>
                <Row className="mx-0 px-0 mt-3 mt-md-0">
                    <Col lg={12} md={12} sm={12} xs={12} className="px-0">
                        <div className="whiteContainer px-md-4 py-md-4 p-2">
                            <div className="tableContainer">
                                <Row className="align-items-center mt-3">
                                    <>
                                        <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                            <div className="input-group-select select-placeholder-center">
                                                <Select
                                                    options={
                                                        statusList.length > 0 ? statusList.map((item, i) => ({ key: i, value: item.value, label: translate(props.lang, item.label) })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                    }
                                                    placeholder={translate(props.lang, "Status")}
                                                    className="input-transparent w-100 text-capitalize"
                                                    styles={customSelectStyles}
                                                    value={statusList.filter(item => item.value === status).map((item, i) => ({ key: i, value: item.value, label: translate(props.lang, item.label) }))}
                                                    name="status"
                                                    isClearable={true}
                                                    isSearchable={false}
                                                    onChange={(e) => setStatus(e ? e.value : '')}
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                            <div className="input-group-select select-placeholder-center">
                                                <Select
                                                    options={
                                                        shownItem.length > 0 ? shownItem.map((item, i) => ({ key: i, value: item.value, label: item.label })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                    }
                                                    placeholder={translate(props.lang, "Result Per Page")}
                                                    className="input-transparent w-100 text-capitalize"
                                                    styles={customSelectStyles}
                                                    isSearchable={false}
                                                    value={shownItem && shownItem.find(option => option.value === productPerpage)}
                                                    name="productPerpage"
                                                    onChange={(e) => setProductPerPage(e.value ? e.value : '')}
                                                />
                                            </div>
                                        </Col>
                                    </>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <Link to="/system/announcement/new" className="primary-btn px-4 py-2 text-center w-100 d-block">
                                            <span className={`btnText`}>{translate(props.lang, "Add Announcement")}</span>
                                        </Link>
                                    </Col>
                                </Row>
                            </div>
                            <>
                                <Table responsive className="w-100 table-list text-center position-relative">
                                    <thead>
                                        <tr>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Date")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Title")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Description")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan={4}>
                                                    <LoadingV3 theme='light' />
                                                </td>
                                            </tr>
                                        ) : (
                                            result.length > 0 ? (
                                                result.map((item, i) => (
                                                    <tr role="row" className={`${i % 2 === 0 ? 'even' : 'odd'}`} key={i}>
                                                        <td className={`font-weight-500 font-16 text-center lh-base`}>{item.date_added ? item.date_added : ''}</td>
                                                        <td className={`font-weight-500 font-16 text-center lh-base`}>{item.title ? item.title : ''}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.description ? item.description.length > 100 ? item.description.substring(0, 100) + '...' : item.description : ''}</td>
                                                        <td className={`font-weight-500 font-16 text-white`}>
                                                            <button onClick={() => edit(item.announcement_id)} className="primary-btn py-2 text-center px-4">
                                                                <span className={`btnText`}>{translate(props.lang, "Edit")}</span>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr role="row" className={`even`}>
                                                    <td colSpan={4}>
                                                        <NotFound />
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </Table>
                                <div className="pt-4">
                                    {!loading && result.length > 0 ? (
                                        <div className="my-3">
                                            <ReactPaginate
                                                previousLabel={"<"}
                                                nextLabel={">"}
                                                pageCount={pageCount}
                                                forcePage={pageNumber - 1}
                                                onPageChange={changePage}
                                                containerClassName={"pagination font-weight-400 font-16 text-uppercase text-grey-2"}
                                                previousLinkClassName={"pagination__previouslink pagination-arrow"}
                                                nextLinkClassName={"pagination__nextlink pagination-arrow"}
                                                disabledClassName={"pagination__link--disabled text-muted"}
                                                activeClassName={"pagination__link--active text-black"}
                                                marginPagesDisplayed={window.innerWidth > 667 ? 3 : 1}
                                            />
                                        </div>
                                    ) : null}
                                </div>
                            </>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
}

const mapStateToProps = state => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
}

export default connect(mapStateToProps)(Announcement);